import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=927cf7ec"
import script from "./CalendarIcon.vue?vue&type=script&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&lang=js"
import style0 from "./CalendarIcon.vue?vue&type=style&index=0&id=927cf7ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports